<ng-container *transloco="let t;">

  <div class="card p-mb-4" *ngIf="visible === true" [ngClass]="{'card-disabled': disabled === true }">

    <app-participant-form [id]="'hiringmanager'" [form]="subForm" [disabled]="disabled" [settings]="settings.hiringmanager"
      [title]="t('common.labels.hiringmanager')" [user]="user" #hiringmanager></app-participant-form>

    <app-participant-form [id]="'hr_businesspartner'" [form]="subForm" [disabled]="disabled" [settings]="settings.hr_businesspartner"
      [title]="t('common.labels.businesspartner')" #hr_businesspartner></app-participant-form>

    <app-participant-form [id]="'executive_contact'" [form]="subForm" [disabled]="disabled" [settings]="settings.executive_contact"
      [title]="t('common.labels.executive_contactperson')" #executive_contact></app-participant-form>

    <app-participant-form [id]="'workers_council'" [form]="subForm" [disabled]="disabled" [wcSpecial]="true"
      [settings]="settings.workers_council" [title]="t('common.labels.workers_council')" #workers_council>
    </app-participant-form>

    <app-participant-form [id]="'disabled_persons_representative'" [form]="subForm" [disabled]="disabled"
      [settings]="settings.disabled_persons_representative" [title]="t('common.labels.repr_disabled_persons')" #disabledpersons>
    </app-participant-form>

    <div class="disabled-screen"><i class="pi pi-lock"></i></div>

  </div>

</ng-container>
